import { useAppSelector } from '@frontend/common';
import { ApplicationConstraintData, isApplicationConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ApplicationConstraintDataInputProps } from './application-constraint-data-input.component';

interface ViewProps {
    formValues: ApplicationConstraintData;
}

const useApplicationConstraintDataInput = (props: ApplicationConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isApplicationConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { application: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useApplicationConstraintDataInput;
